import { Component, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { TypeInventoryModel } from 'src/app/models/inventory/type-inventory.model';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { TypeInventoryService } from '../../../../services/inventory/type-inventory.service';

@Component({
  selector: 'app-register-type-inventory',
  templateUrl: './register-type-inventory.component.html',
  styleUrls: ['./register-type-inventory.component.scss'],
  standalone: false
})
export class RegisterTypeInventoryComponent implements OnInit {
  typeInventoryContract: TypeInventoryModel = new TypeInventoryModel();
  typeInventoryId: number = 0;
  formTypeInventory: FormGroup = new FormGroup({});
  listDepartments: any[] = [];
  subscription: Subscription;

  constructor(public config: DynamicDialogConfig,
    private formBuilder: FormBuilder,
    @Optional() private ref: DynamicDialogRef,
    private toastHandlerService: ToastHandlerService,
    private typeInventoryService: TypeInventoryService) {
  }

  ngOnInit(): void {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.subscription = input$?.subscribe((inputs: any) => {
      this.typeInventoryContract = inputs.typeInventoryModel;
      if (this.typeInventoryContract.typeInventoryId != 0) {
        this.typeInventoryId = this.typeInventoryContract.typeInventoryId;
      }
      this.validateForm(new TypeInventoryModel());
      this.handleInitialState();
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  changeTypeInventory() {
    const code = this.formTypeInventory.get("code")?.value;

    if (code != 0) {
      this.getTypeInventoryByCode(code);
    } else {
      this.createNewTypeInventory();
    }
  }

  createNewTypeInventory() {
    this.typeInventoryId = 0;
    this.typeInventoryContract = new TypeInventoryModel();
    this.validateForm(this.typeInventoryContract);
    setTimeout(() => this.formTypeInventory.controls["code"].disable(), 100);
  }

  async getTypeInventoryByCode(code: number) {
    try {
      this.typeInventoryContract = await firstValueFrom(this.typeInventoryService.getTypeInventoryByCode(code));
      this.typeInventoryId = this.typeInventoryContract.typeInventoryId;
      this.validateForm(this.typeInventoryContract);
    } catch (error) {
      console.error('Error al buscar el tipo de inventario por código.', error);
    }
  }

  async getTypeInventoryById() {
    try {
      this.typeInventoryContract = await firstValueFrom(this.typeInventoryService.getTypeInventoryById(this.typeInventoryId));
      this.typeInventoryId = this.typeInventoryContract.typeInventoryId;
      await this.validateForm(this.typeInventoryContract);
    } catch (error) {
      console.error('Error al buscar el tipo inventario por id.', error);
    }
  }

  async handleInitialState() {
    if (this.typeInventoryId !== null && this.typeInventoryId !== 0) {
      await this.getTypeInventoryById();
    } else {
      this.createNewTypeInventory();
    }
  }

  async send() {
    Object.keys(this.formTypeInventory.controls).forEach(key => {
      const control = this.formTypeInventory.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });

    if (this.formTypeInventory.valid) {
      const modelTypeInventory = this.formTypeInventory.getRawValue();

      if (this.typeInventoryId == 0) {
        try {
          const response = await firstValueFrom(this.typeInventoryService.createTypeInventory(modelTypeInventory));
          this.toastHandlerService.showToast('success', `El tipo de inventario fue creada exitosamente.`);
          this.typeInventoryContract = response;
          this.typeInventoryId = this.typeInventoryContract.typeInventoryId;
          this.validateForm(this.typeInventoryContract);
        } catch (error) {
          console.error('Error al crear el tipo de inventario.', error);
        }
      } else {
        this.typeInventoryContract.name = modelTypeInventory.name;
        try {
          const response = await firstValueFrom(this.typeInventoryService.updateTypeInventory(this.typeInventoryContract));
          this.toastHandlerService.showToast('success', `El tipo de inventario fue modificada exitosamente.`);
          this.typeInventoryContract = response;
          this.validateForm(this.typeInventoryContract);
        } catch (error) {
          console.error('Error al actualizar el tipo de inventario.', error);
        }
      }
      const output$ = this.config.data?.output$;
      output$?.next({ type: 'reload' });
    } else {
      this.showValidationMessages();
    }
  }
  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      code: {
        required: 'La código es obligatirio.',
        maxlength: 'El campo código permite máximo 3 caracteres.'
      },
      name: {
        required: 'El nombre es obligatorio.',
        maxlength: 'El campo nombre permite máximo 50 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formTypeInventory.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  validateForm(typeInventory: TypeInventoryModel) {
    this.formTypeInventory = this.formBuilder.group({
      code: [typeInventory.code, []],
      name: [typeInventory.name, [Validators.required, Validators.maxLength(50)]]
    });
  }
}
